import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/general/confirm-dialog/confirm-dialog.component';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { FactuurService } from 'src/app/shared/dataservices/factuur.service';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { FactuurInfo } from 'src/app/shared/model/factuur';
import { ActiveRelatie, Relatie } from 'src/app/shared/model/relatie';

@Component({
  selector: 'app-factuur-edit-line',
  templateUrl: './factuur-edit-line.component.html',
  styleUrls: ['./factuur-edit-line.component.less']
})
export class FactuurEditLineComponent implements OnInit {

  @Input() factuurline : FactuurInfo;
  @Output() newLine =  new EventEmitter<FactuurInfo>();
  @Output() deleted =  new EventEmitter<number>();
  relaties : Array<ActiveRelatie>;
  statusList: any;

  constructor(private relatiesService: RelatiesService,
    private objectenService: ObjectenService,
    private factuurService: FactuurService,
    private dialog: MatDialog,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.relatiesService.getActiveRelatieList().subscribe(data => {
      this.relaties = data;
    })

    this.objectenService.getStatusList().subscribe(data => {
      this.statusList = data;
    })

  }


  save() {
        this.factuurService.saveFactuurInfo(this.factuurline.ID, this.factuurline).subscribe(data => {
          this.toastr.success("", "Opgeslagen");
        })
  }

  getRelatie() {
    const relatie = this.relaties.find(e => e.BedrijfNummer == this.factuurline.BedrijfNummer );
    return relatie.Afkorting;
  }
  getStatus() {
    const status = this.statusList.find(e => e.ID == this.factuurline.StatusCodeID );
    return status.StatusCode
  }

  delete() {
    const message = `Weet je zeker dat je dit wilt doen?`;

    const dialogData = new ConfirmDialogModel("Bevestig verwijdering", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      const result = dialogResult;
      if (result) {
          this.factuurService.deleteFactuurInkoop(this.factuurline.ID).subscribe(() => {
            this.toastr.error("", "Verwijderd");
            this.deleted.emit(this.factuurline.ID)
          }
          );
        }
      });

  }

  format(value: number | string) {
    let amount = value ? value.toString() : '0';
    amount = amount.replace(/\s/g, '');
    amount = amount.replace(/,/g, '');
    amount = amount.replace(/\./g, '');
    return (Number(amount) / 100).toLocaleString("nl", { minimumFractionDigits: 2 });
  }

}
